import gql from 'graphql-tag';

const GET_CUSTOMER_IDENTITY_TOKEN = gql`
  query {
    getCustomerIdentityToken
  }
`;

const GET_ALL_CLIENT_DATA = gql`
  query($listInfo: ListInfoInput!) {
    getClientList(listInfo: $listInfo) {
      clients {
        accountId
        name
        primaryContact {
          email
          phoneNumber
          contactNumber
        }
        technicianGroups {
          name
          groupId
        }
        emailDomains
      }
      listInfo {
        hasMore
      }
    }
  }
`;

export { GET_CUSTOMER_IDENTITY_TOKEN, GET_ALL_CLIENT_DATA };
